import {Button, Descriptions, Form, Input, message, Modal, Switch, Tabs, Tag} from 'antd';
import {EditOutlined, InfoCircleOutlined} from '@ant-design/icons';
import {Content} from 'antd/lib/layout/layout';
import {STATION_GROUP} from './stationGroups.type';
import StationGroupEmployeesList from './stationGroupEmployees';
import StationGroupStationsList from './stationGroupStations';
import {useState} from 'react';
import {useAppDispatch, useAppSelector} from '../../../../common/hooks';
import {groupList, updateStationGroup} from './stationGroupsSlice';
import {formatDate} from '../../../../utils/formatDate';
import type {UPDATE_STATION} from '../stations/stations.type';
import checkFormUpdate from '../../../../utils/checkFormUpdate';

const Gorups = ({station}: {station: STATION_GROUP}) => {
  const dispatch = useAppDispatch();
  const [editGrpNameModal, setEditGrpNameModal] = useState(false);
  const userPermission = useAppSelector((state) => state.config.config.permissions);
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);

  const [editGrpNameForm] = Form.useForm();

  const handleEdit = (value: UPDATE_STATION) => {
    const payload = checkFormUpdate(value, station);
    if (Object.keys(payload).length > 0) {
      dispatch(
        updateStationGroup({
          groupId: station.id,
          payload: {name: value.name, is_active: value.is_active},
        }),
      )
        .unwrap()
        .then(() => {
          setEditGrpNameModal(false);
          editGrpNameForm.resetFields();
          dispatch(groupList());
        });
    } else {
      message.warning('No value changed');
    }
  };
  return (
    <>
      <Content
        style={{background: '#ffffff', height: '100%', padding: '0px'}}
        className='groupTabs'
      >
        <Tabs
          defaultActiveKey='0'
          destroyInactiveTabPane
          tabPosition={'top'}
          style={{height: '100%', width: '100%'}}
          type='card'
          items={[
            {
              label: 'Stations',
              key: '1',
              children: <StationGroupStationsList groupId={station.id} />,
            },
            {
              label: 'Employees',
              key: '2',
              children: <StationGroupEmployeesList groupId={station.id} />,
            },
          ]}
          tabBarExtraContent={
            <>
              <Button
                type='primary'
                style={{borderRadius: '5px', marginInline: '5px'}}
                icon={<InfoCircleOutlined />}
                onClick={() => {
                  setIsInfoModalOpen(true);
                }}
              >
                Info Group
              </Button>
              {userPermission.update_stationgroup && (
                <Button
                  type='primary'
                  style={{borderRadius: '5px', marginInline: '5px'}}
                  icon={<EditOutlined />}
                  onClick={() => {
                    setEditGrpNameModal(true);
                    editGrpNameForm.setFieldsValue({
                      name: station.name,
                      is_active: station.is_active,
                    });
                  }}
                >
                  Edit Group
                </Button>
              )}
            </>
          }
        />
      </Content>
      <Modal
        title={`${station.name}`}
        open={isInfoModalOpen}
        onCancel={() => {
          setIsInfoModalOpen(false);
        }}
        footer={null}
        width={800}
      >
        <Descriptions bordered column={2}>
          <Descriptions.Item label='Group Name' labelStyle={{fontWeight: 'bolder'}}>
            {station.name}
          </Descriptions.Item>

          <Descriptions.Item label='Status' labelStyle={{fontWeight: 'bolder'}}>
            {station.is_active ? <Tag color='green'>Active</Tag> : <Tag color='red'>Inactive</Tag>}
          </Descriptions.Item>

          <Descriptions.Item label='Created By' labelStyle={{fontWeight: 'bolder'}}>
            {station.created_by}
          </Descriptions.Item>
          <Descriptions.Item label='Created At' labelStyle={{fontWeight: 'bolder'}}>
            {formatDate(station.created_at)}
          </Descriptions.Item>
          <Descriptions.Item label='Updated By' labelStyle={{fontWeight: 'bolder'}}>
            {station.updated_by}
          </Descriptions.Item>
          <Descriptions.Item label='Updated At' labelStyle={{fontWeight: 'bolder'}}>
            {formatDate(station.updated_at)}
          </Descriptions.Item>
        </Descriptions>
      </Modal>
      <Modal
        title='Add Employee In Station Group'
        open={editGrpNameModal}
        onCancel={() => {
          editGrpNameForm.resetFields();
          setEditGrpNameModal(false);
        }}
        okText={'Add'}
        maskClosable={false}
        style={{height: '700px', width: '800px'}}
        onOk={() => {
          editGrpNameForm
            .validateFields()
            .then((values) => {
              handleEdit(values);
            })
            .catch((info) => {
              console.error('Validate Failed:', info);
            });
        }}
      >
        <Form
          form={editGrpNameForm}
          name='Edit station Name'
          labelCol={{span: 16}}
          wrapperCol={{span: 16}}
          layout='vertical'
        >
          <Form.Item
            label='Station Group Name'
            name='name'
            rules={[
              {required: true, message: 'Please enter a name'},
              {min: 4, message: 'Atleast 4 characters are required'},
            ]}
          >
            <Input autoComplete='off' placeholder='Group Name' />
          </Form.Item>
          <Form.Item name='is_active' label='Status' valuePropName='checked'>
            <Switch checkedChildren='Active' unCheckedChildren='Inactive' />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default Gorups;
